module.exports = __webpack_public_path__ + "static/ibotta_logo1-0c097143d740fb2672847f4c84ff8aaa.png";